// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"28":"e1dc4e48c716837f","715":"a7276d83d041b5bc","734":"2e1dc2de5506a7b2"}[chunkId] + ".js";
};